import React from "react";
import Modal from "./Modal.tsx";

export const WarningModal = ({
  isOpen,
  onCancel,
  title,
  message,
  onConfirm,
  isLoading,
}) => {
  if (!isOpen) return null;

  return (
    <Modal
      title={title}
      size="md"
      onCancel={() => onCancel(false)}
      isOpen={isOpen}
    >
      <div>
        <p className="warning__message">{message}</p>

        <div className="d-flex">
          <button
            onClick={() => onConfirm()}
            className="btn btn--sm btn__primary"
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Confirm"}
          </button>
          <button onClick={() => onCancel(false)} className="btn btn--sm">
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};
